<template>
    <div :class="['page', language === 'cn' ? 'font-cn' : 'font-en']">
      <!-- Content Section and Navigation Together -->
      <div class="content-wrapper">
        <!-- Content Section -->
        <div class="content-section">
          <div v-for="(item, index) in content.Items" :key="index" class="content-item">
            <div class="card">  
              <div class="card-body">
                <h1 class="title">{{ item.title }}</h1>
                <div v-html="formattedDescription(item.description_1)" class="description"></div>
                <div class="card-header">
                  <img :src="item.image_1" alt="Content Image" class="image" />
                </div>  
                <div v-html="formattedDescription(item.description_2)" class="description"></div>
                <div class="card-header">
                  <img :src="item.image_2" alt="Content Image" class="image" />
                </div>
                <div v-html="formattedDescription(item.description_3)" class="description"></div>  
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </template>
  
  <style src="@/assets/css/news.css" scoped></style>
  
  <script>
  import { mapState } from "vuex";
  export default {
    data() {
      return {
        cn: {
          Items: [
            {
              id: 1,
              image_1: require("@/assets/img/News/012/Vistors.jpg"),
              image_2: require("@/assets/img/News/012/Group.jpg"),
              title: "云翰虹章大空间VR项目亮相海丝文旅大展",
              description_1:`
                10月25日至27日，第九届浙江书展、2024海丝之路文化和旅游博览会、2024宁波国际旅游展（简称“海丝文旅大展”）在宁波国际会展中心盛大举行。本次大展以“经典共读 文化共享 文旅共融”为主题，首次以“三展合一”的形式推出，展现了文化与旅游的创新融合。
              `,
              description_2:`
                作为展会的一大亮点，云翰虹章团队携其大空间VR项目在鄞州展区首次亮相，为观众带来了全新的VR沉浸式体验。云翰虹章团队此次展示的VR内容不仅彰显了其在虚拟现实制作领域的技术实力，也为推动“海丝之路”文化的数字化表达和国际传播提供了新的视角。
                
                该创新项目也吸引了匈牙利的科技领事、文化领事及艺术家代表团的关注。代表团来到云翰虹章的展区，对项目的技术与内容表示高度赞赏。在参观过程中，匈牙利代表团详细了解了VR项目的技术细节与创意理念，并与云翰虹章团队成员亲切交流，探讨了虚拟现实技术在文化传播中的应用与前景。参观结束后，匈牙利代表团与云翰虹章团队进行了合影，记录下了这一中匈科技与文化交流的重要时刻。
              `,
              description_3:`
                此次云翰虹章的大空间VR项目不仅展示了先进的虚拟现实技术在文化领域的应用，也促进了中匈两国在文化和科技领域的深度交流。
              `,

            },
            // Add more items as needed
          ],
        },
        en: {
          Items: [
            {
              id: 1,
              image_1: require("@/assets/img/News/012/Vistors.jpg"),
              image_2: require("@/assets/img/News/012/Group.jpg"),
              title: "Showcase of Rosy Nebula's Large Space VR Project",
              description_1:`
                From 25 to 27 October, the 9th Zhejiang Book Fair, 2024 Ningbo Maritime Sild Road Culture and Tourism Expo, and 2024 Ningbo International Tourism Expo (referred to as Maritime Sild Road Culture and Tourism Expo) were held in Ningbo International Convention and Exhibition Center.

                With the theme of ‘Reading Classics and Sharing Culture, Culture and Tourism’, the exhibition was launched for the first time in the form of ‘three exhibitions in one’, showing the innovative integration of culture and tourism.
              `,
              description_2:`
                As one of the highlights of the exhibition, Rosy Nebula team with its large space VR project debut in Yinzhou exhibition area, bringing a new VR immersive experience for the audience. Rosy Nebula team's VR content not only highlights its technical strength in the field of virtual reality production, but also for the promotion of the ‘Sea Silk Road’ digital expression of culture and international dissemination provides a new perspective.
                
                The innovative project also attracted the attention of the Hungarian Consul of Science and Technology, Consul of Culture and a delegation of artists. The delegation came to the exhibition area of Rosy Nebula and highly appreciated the technology and content of the project. During the visit, the Hungarian delegation learnt more about the technical details and creative concepts of the VR project, and exchanged views with Rosy Nebula's team members to discuss the application and prospects of virtual reality technology in cultural communication. After the visit, the Hungarian delegation took a group photo with the Rosy Nebula team, recording this important moment of technological and cultural exchange between China and Hungary.
              `,
              description_3:`
                The large space VR project of Rosy Nebula not only demonstrates the application of advanced virtual reality technology in the cultural field, but also promotes in-depth exchanges between China and Rosy Nebula in the fields of culture and science and technology.
              `,

            },
            // Add more items as needed
          ],
        },
      };
    },
    methods: {
      formattedDescription(description) {
        // Apply additional formatting if needed
        return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
      },
      formattedDescriptionNo(description_no) {
        // Apply additional formatting if needed
        return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
      },
    },
    mixins: [],
    computed: {
      ...mapState(["language"]),
      content() {
        const defaultContent = { title: "", industry_areas: [] };
        const currentLanguage = this.language === "en" ? this.en : this.cn;
        console.log("Current Language:", currentLanguage); // Debug statement
        return currentLanguage || defaultContent;
      },
    },
    watch: {
      language(newValue) {
        console.log("Language changed to:", newValue); // Debug statement
        this.$forceUpdate(); // Force the component to re-render when the language changes
      },
    },
  };
  </script>
